import React, { useContext, useEffect, useState } from "react";
import { BuilderContext } from "./BuilderContext";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AppSettings from "../../../Settings/AppSettings";
import AuthManager from "../../../Common/AuthManager";
import BuilderHeader from "./Components/BuilderHeader";
import BuilderComponentList from "./Components/BuilderComponentList";
import BuilderPreviewList from "./Components/BuilderPreviewList";
import { CSSTransition } from "react-transition-group";
import { toast } from "Components/DesignSystem/Toast/useToast";
import ChannelPreview from "./Components/ChannelPreview";
import Label from "../../Common/components/Label";

function BuilderAddEditManage({ builderId }) {
  const {
    masterdata,
    builder_template,
    format_builder,
    industryId,
    partyId,
    platformInfo,
    setGlobalFilter,
  } = useContext(BuilderContext);
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const [builderdetailId, setBuilderdetailId] = useState(builderId);
  const [editPage, setEditPage] = useState(false);
  const [edited, setEdited] = useState(false);
  const [builderDetails, setBuilderDetails] = useState(null);
  const [builderHeaderDetails, setBuilderHeaderDetails] = useState(null);
  const [builderComponentDetails, setBuilderComponentDetails] = useState(null);
  const [builderPreview, setBuilderPreview] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [showChannel, setShowChannel] = useState(false);
  const [channelResponse, setChannelResponse] = useState(null);
  const [showBuilder, setShowBuilder] = useState(false);
  const [merchantKey, setMerchantKey] = useState("");
  const [token, setToken] = useState("");
  const [mainBuilder, setMainBuilder] = useState(null);

  useEffect(() => {
    if (builderId && builderId !== "0" && industryId) {
      load_Builder_Details(builderId);
    } else if (industryId) {
      setEditPage(false);
      setBuilderDetails(builder_template);
    }
  }, [builderId, industryId]);

  const editedBuilderDetail = (data) => {
    setBuilderDetails(data);
    setEdited(true);
  };
  async function load_Builder_Details(builderId) {
    setEditPage(true);
    setBuilderHeaderDetails(null);
    let ret = await ServiceWrapper.doGet(
      `${api_base_url}builder/${builderId}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!ret.errorfound && ret.data && ret.data.done) {
      let builderDet = ret?.data?.data;
      setMainBuilder(builderDet);
      setBuilderDetails(
        builderDet.draft ?? builderDet.live ?? builderDet.rollback
      );
      setEditPage(true);
    } else {
      toast.error("Error while Loading Builder");
    }
  }

  useEffect(() => {
    if (builderDetails) {
      if (builderDetails.builder) {
        setBuilderHeaderDetails(builderDetails.builder);
      }
      if (builderDetails.components) {
        setBuilderComponentDetails(builderDetails.components);
      }
      setGlobalFilter(builderDetails?.builder?.global_filter ?? []);
    }
  }, [builderDetails]);

  async function preview_builder_Details() {
    const final_builder = format_builder(builderDetails);
    let res = await ServiceWrapper.doPost(
      `${api_base_url}builder/model`,
      final_builder,
      null,
      AuthManager.getGmsToken()
    );
    if (res && !res.errorfound) {
      if (res.data && res.data.done) {
        setShowPreview(true);
        setBuilderPreview(res.data.data);
        return true;
      } else {
        setShowPreview(false);
        toast.error(res.data.message);
        return false;
      }
    } else {
      setShowPreview(false);
      toast.error("Error while loading Builder preview");
      return false;
    }
  }

  async function preview_channel() {
    let res = await ServiceWrapper.doGet(
      `${api_base_url}party/${partyId}/channel`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (res.data.done) {
      setShowChannel((prev) => (prev = !prev));
      setChannelResponse(res.data.data);
    } else {
      console.log("handle error");
    }
  }

  return (
    <>
      <div className="overflow-hidden pe-0 ps-0 pt-0">
        {!showBuilder && (!builderHeaderDetails || !masterdata) && (
          <div>
            <div className="">
              <div className="border-bottom pe-2 ps-4 row">
                <div className="col-6">
                  <div className="col-4 p-3 skeleton"></div>
                </div>
                <div className="col-6 justify-content-end pe-1 row">
                  <div className="skeleton col-6"></div>
                </div>
              </div>
            </div>
            <div className="pb-3 pe-2 ps-4 border-bottom">
              <div className="ps-2 pt-4 row">
                <div className="col-6 p-3 skeleton"></div>
                <div className="col-3 mb-4 ms-5 mt-3 skeleton"></div>
              </div>
              <div className="col-6 p-4 skeleton"></div>
            </div>
            <div className="p-4">
              <div className="border p-2 rounded">
                <div className="ms-5 ps-3 mt-3 row">
                  <div className="col-2 p-3 skeleton"></div>
                  <div className="col-2 ms-5 p-3 skeleton"></div>
                  <div className="col-2 ms-5 p-2 skeleton"></div>
                </div>
                <div className="ms-3 mt-5 ps-5">
                  <div className="col-8 p-3 skeleton"></div>
                </div>
                <div className="ms-3 mt-5 ps-5">
                  <div className="col-8 p-3 skeleton"></div>
                </div>
                <div className="ms-3 mt-5 ps-5">
                  <div className="col-8 p-3 skeleton"></div>
                </div>
              </div>
            </div>
            <div className="col-2 ms-4 p-3 skeleton"></div>
          </div>
        )}
        {!showBuilder && builderHeaderDetails && builderComponentDetails && (
          <>
            <BuilderHeader
              builderId={builderdetailId}
              setBuilderdetailId={setBuilderdetailId}
              headerdetails={builderHeaderDetails}
              editPage={editPage}
              load_Builder_Details={load_Builder_Details}
              builderDetails={builderDetails}
              setUpdatedBuilderDetails={editedBuilderDetail}
              edited={edited}
              preview_builder_Details={preview_builder_Details}
              preview_channel={preview_channel}
              mainBuilder={mainBuilder}
              setBuilderDetails={setBuilderDetails}
              setBuilderComponentDetails={setBuilderComponentDetails}
            />
            {masterdata && (
              <BuilderComponentList
                builderId={builderdetailId}
                builderComponentDetails={builderComponentDetails}
                setBuilderDetails={setBuilderDetails}
                editPage={editPage}
                builderDetails={builderDetails}
                setUpdatedBuilderDetails={editedBuilderDetail}
                setBuilderPreview={setBuilderPreview}
                setShowPreview={setShowPreview}
                preview_builder_Details={preview_builder_Details}
              />
            )}
            {showPreview && builderPreview && (
              <CSSTransition
                timeout={1000}
                key={showPreview}
                classNames={{
                  enterActive: "animate__animated animate__flipInX",
                  exitActive: "animate__animated animate__flipOutX",
                }}
              >
                <BuilderPreviewList
                  builderPreview={builderPreview}
                  setShowPreview={setShowPreview}
                />
              </CSSTransition>
            )}
            {showChannel && channelResponse && (
              <CSSTransition
                timeout={1000}
                key={showChannel}
                classNames={{
                  enterActive: "animate__animated animate__flipInX",
                  exitActive: "animate__animated animate__flipOutX",
                }}
              >
                <ChannelPreview
                  channelResponse={channelResponse}
                  setShowChannel={setShowChannel}
                  setShowBuilder={setShowBuilder}
                  setMerchantKey={setMerchantKey}
                  platformInfo={platformInfo}
                  setToken={setToken}
                />
              </CSSTransition>
            )}
          </>
        )}
        {showBuilder && builderHeaderDetails && (
          <div className="w-100 h-100 p-0 m-0">
            <div className="col card">
              <div className="d-flex pb-0 pt-0 justify-content-between align-items-center">
                <div style={{ float: "left" }}>
                  <i data-testid="builder-builderaddeditmanage-i-1"
                    id="btnGroupDrop1"
                    className="fas fa-angle-left pt-1 pe-2"
                    style={{
                      fontSize: "1rem",
                      cursor: "pointer",
                      color: "#5c5f62",
                    }}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    onClick={() => {
                      setShowBuilder((prev) => (prev = !prev));
                    }}
                  />
                  <Label
                    message={builderHeaderDetails.name}
                    fontSize={1.125}
                    fontWeight="700"
                  />
                </div>
              </div>
            </div>
            <div className="d-flex w-100">
              <iframe
                style={{ height: "100vh", width: "inherit" }}
                //src={`https://apps.compat.io/?merchantKey=iuX5FUzHpou813o5B30m&builderModel=39c23b6c01f311ed96492a9f4261eaf9&authToken=l9LcJuS8h6AOXsWErPX5SfmcETfmzJQXEjIDd&variantId=37564033171631`}
                //src={`https://apps.compat.io/?merchantKey=${merchantKey}&builderModel=${builderHeaderDetails.uid}&authToken=${token}`}
                src={`https://apps.compat.io/?builderModel=${builderHeaderDetails.uid}&merchantKey=${merchantKey}&authToken=${token}`}
                id="iframe_view_builder"
                title="Product Builder"
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default BuilderAddEditManage;
